
/*
export default class ByteDecoder {
  #bytes
  #max
  #index
  #component = null

  static MAX_CHUNK_LENGTH = 0x1000

  static decode (bytes) {
    const byteDecoder = new ByteDecoder(bytes)
    const codePoints = []
    let response = ''
    let index = 0
    let result = byteDecoder.next()

    while (!result.done) {
      codePoints.push(result.value)
      result = byteDecoder.next()
    }

    const { length } = codePoints
    if (length <= ByteDecoder.MAX_CHUNK_LENGTH) {
      return String.fromCharCode.apply(String, codePoints)
    }

    while (index < length) {
      response += String.fromCharCode.apply(
        String,
        codePoints.slice(index, index += ByteDecoder.MAX_CHUNK_LENGTH)
      )
    }

    return response
  }

  constructor (bytes) {
    this.#bytes = bytes
    this.#max = bytes.length
    this.#index = -1
    this.next = this.next.bind(this)
  }

  get [Symbol.toStringTag] () {
    return 'ByteDecoder'
  }

  [Symbol.iterator] () {
    return this
  }

  next () {
    const result = { value: null, done: false }
    if (this.#component) {
      result.value = this.#component
      this.#component = null
      return result
    }
    ++this.#index
    // done
    if (this.#index >= this.#max) {
      return { value: undefined, done: true }
    }

    const li = this.#max - this.#index
    const firstByte = this.#bytes[this.#index]
    let codePoint = null

    if (firstByte > 0xfb && firstByte < 0xfe && li > 7) {
      codePoint = (firstByte & 0xf) << 0x1e
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x18
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x12
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0xc
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x6
      codePoint |= this.#bytes[++this.#index] & 0x3f
    } else if (firstByte > 0xf7 && li > 4) {
      codePoint = (firstByte & 0xf) << 0x18
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x12
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0xc
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x6
      codePoint |= this.#bytes[++this.#index] & 0x3f
    } else if (firstByte > 0xef && li > 3) {
      codePoint = (firstByte & 0xf) << 0x12
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0xc
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x6
      codePoint |= this.#bytes[++this.#index] & 0x3f
    } else if (firstByte > 0xdf && li > 2) {
      codePoint = (firstByte & 0xf) << 0xc
      codePoint |= (this.#bytes[++this.#index] & 0x3f) << 0x6
      codePoint |= this.#bytes[++this.#index] & 0x3f
    } else if (firstByte > 0xbf && li > 1) {
      codePoint = (firstByte & 0x1f) << 0x6
      codePoint |= this.#bytes[++this.#index] & 0x3f
    } else if (firstByte < 0x80) {
      codePoint = firstByte
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xfffd
    } else if (codePoint > 0xffff) {
      // encode to utf16 (surrogate pair)
      codePoint -= 0x10000
      result.value = ((codePoint >>> 10) & 0x3ff) | 0xd800
      this.#component = 0xdc00 | (codePoint & 0x3ff)
      return result
    }

    result.value = codePoint
    return result
  }
}
*/

export default class ByteDecoder {
  #encoding

  static MAX_CHUNK_LENGTH = 0x1000

  constructor () {
    this.#encoding = 'utf-8'
  }

  get encoding () {
    return this.#encoding
  }

  get [Symbol.toStringTag] () {
    return 'ByteDecoder'
  }

  decode (bytes) {
    const codePoints = this.#internalDecode(bytes)
    const { length } = codePoints
    let index = 0
    let response = ''

    if (length <= ByteDecoder.MAX_CHUNK_LENGTH) {
      return String.fromCharCode(...codePoints)
    }

    while (index < length) {
      response += String.fromCharCode(
        ...codePoints.slice(index, index += 0x1000)
      )
    }

    return response
  }

  #internalDecode (bytes) {
    const { length } = bytes
    const chunks = []
    let index = -1

    while (++index < length) {
      const li = length - index
      const firstByte = bytes[index]
      let codePoint = null

      if (firstByte > 0xf7 && li > 4) {
        codePoint = (firstByte & 0xf) << 0x18
        codePoint |= (bytes[++index] & 0x3f) << 0x12
        codePoint |= (bytes[++index] & 0x3f) << 0xc
        codePoint |= (bytes[++index] & 0x3f) << 0x6
        codePoint |= bytes[++index] & 0x3f
      } else if (firstByte > 0xef && li > 3) {
        codePoint = (firstByte & 0xf) << 0x12
        codePoint |= (bytes[++index] & 0x3f) << 0xc
        codePoint |= (bytes[++index] & 0x3f) << 0x6
        codePoint |= bytes[++index] & 0x3f
      } else if (firstByte > 0xdf && li > 2) {
        codePoint = (firstByte & 0xf) << 0xc
        codePoint |= (bytes[++index] & 0x3f) << 0x6
        codePoint |= bytes[++index] & 0x3f
      } else if (firstByte > 0xbf && li > 1) {
        codePoint = (firstByte & 0x1f) << 0x6
        codePoint |= bytes[++index] & 0x3f
      } else if (firstByte < 0x80) {
        codePoint = firstByte
      }

      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xfffd
      } else if (codePoint > 0xffff) {
        // encode to utf16 (surrogate pair)
        codePoint -= 0x10000

        chunks.push(
          ((codePoint >>> 10) & 0x3ff) | 0xd800,
          0xdc00 | (codePoint & 0x3ff)
        )
        continue
      }

      chunks.push(codePoint)
    }

    return chunks
  }
}

export function utf8Decode (bytes) {
  const codePoints = []
  let index = 0
  let nextIndex = 0
  let response = ''

  for (const byte of decodeUtf8(bytes)) {
    codePoints[nextIndex++] = byte
  }

  if (nextIndex <= 0x1000) {
    return String.fromCharCode.apply(String, codePoints)
  }

  while (index < nextIndex) {
    response += String.fromCharCode.apply(
      String,
      codePoints.slice(index, index += 0x1000)
    )
  }

  return response
}

function * decodeUtf8 (bytes) {
  const { length } = bytes
  let index = -1

  while (++index < length) {
    const li = length - index
    const firstByte = bytes[index]
    let codePoint = null

    if (firstByte > 0xf7 && li > 4) {
      codePoint = (firstByte & 0xf) << 0x18
      codePoint |= (bytes[++index] & 0x3f) << 0x12
      codePoint |= (bytes[++index] & 0x3f) << 0xc
      codePoint |= (bytes[++index] & 0x3f) << 0x6
      codePoint |= bytes[++index] & 0x3f
    } else if (firstByte > 0xef && li > 3) {
      codePoint = (firstByte & 0xf) << 0x12
      codePoint |= (bytes[++index] & 0x3f) << 0xc
      codePoint |= (bytes[++index] & 0x3f) << 0x6
      codePoint |= bytes[++index] & 0x3f
    } else if (firstByte > 0xdf && li > 2) {
      codePoint = (firstByte & 0xf) << 0xc
      codePoint |= (bytes[++index] & 0x3f) << 0x6
      codePoint |= bytes[++index] & 0x3f
    } else if (firstByte > 0xbf && li > 1) {
      codePoint = (firstByte & 0x1f) << 0x6
      codePoint |= bytes[++index] & 0x3f
    } else if (firstByte < 0x80) {
      codePoint = firstByte
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xfffd
    } else if (codePoint > 0xffff) {
      // encode to utf16 (surrogate pair)
      codePoint -= 0x10000

      yield * [
        ((codePoint >>> 10) & 0x3ff) | 0xd800,
        0xdc00 | (codePoint & 0x3ff)
      ]
      continue
    }

    yield codePoint
  }
}
